export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/obs_studio.30448c7.svg";